export default "__VITE_ASSET__CaD$BbQi__"